module.exports = __webpack_public_path__ + "static/media/classResultApply.d9a1e843.xlsx";